import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from 'moment';
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Container, Modal } from "react-bootstrap";
import Header2 from "../../components/Header2";
import { LuPhone } from "react-icons/lu";
import { AiOutlineMail } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css";
import { useFieldArray, useForm } from "react-hook-form";
import { ProfileContext } from "../../context/ProfileContext";
import { IMAGE_URL } from "../../API";
import avtar from "../../Assets/Images/image copy 2.png";
import { useMedicalHistoryUpload } from "../../hooks/profile/useMedicalHistoryUpload";
import { IoMdCloseCircle } from "react-icons/io";

function EditMedicalHistory() {
  const [quitDate, setQuitDate] = useState();
  const { profile, editMedicalInfo, keyHandler, TOKEN, getPastHistory } = useContext(ProfileContext);
  const medical = useMedicalHistoryUpload(TOKEN, getPastHistory);
  const navigate = useNavigate();
  const { control, register, handleSubmit, formState: { errors }, watch, reset, setValue, getValues } = useForm({
    defaultValues: {
      family_history: [{ disease: '', family_member: '' }],
      current_medications: [{ medication: '', strength: '', dosage_form: '', frequency: '' }],
      medication_allergy: [{ medication: '', reaction: '' }],
    },
  });


  const { fields: FamilyMemberFields, append: appendFamilyMember, remove: removeFamilyMember } = useFieldArray({ control, name: "family_history" });
  const { fields: medicineFields, append: appendMedicine, remove: removeMedicine } = useFieldArray({ control, name: "current_medications" });
  const { fields: allergiesFields, append: appendAllergy, remove: removeAllergy } = useFieldArray({ control, name: "medication_allergy" });

  const watchMedicalHistory = watch("no_medical_history");
  const watchSurgicalHistory = watch("never_had_surgery");
  const watchFormerSmoker = watch("social_history.former_smoker");
  const watchNeverSmoker = watch("never_smoker");
  const watchNonAlcoholic = watch("non_alcoholic");
  const watchNonDruggist = watch("non_druggist");
  const watchNoMedication = watch("no_medication");
  const watchNoMedicationAllergy = watch("no_medication_allergy");
  const watchMedicalOthers = watch("medical_history.others");
  const watchSurgicalOthers = watch("surgical_history.others");
  const watchOrthopedicSurgery = watch("surgical_history.orthopedic_surgery");
  const watchMediction = watch("current_medications");
  const watchAllergies = watch("medication_allergy");
  const watchAlcoholic = !watchNonAlcoholic;
  const watchDruggist = !watchNonDruggist;

  const allMedicalHistory = watch("medical_history");
  const allSurgicalHistory = watch("surgical_history");
  const allSocialHistory = watch("social_history");
  const allAlcoholHistory = watch("alcohol_history");
  const allDrugHistory = watch("drug_history");

  const resetSectionFields = (sectionName, formValues) => {
    if (!formValues) return;
    if (typeof formValues === 'object' && !Array.isArray(formValues)) {
      Object.keys(formValues).forEach(key => {
        const fieldPath = `${sectionName}.${key}`;
        const value = formValues[key];
        if (typeof value === 'boolean') {
          setValue(fieldPath, false);
        } else if (typeof value === 'string') {
          setValue(fieldPath, "");
        } else if (typeof value === 'number') {
          setValue(fieldPath, 0);
        } else if (Array.isArray(value)) {
          setValue(fieldPath, []);
        } else if (typeof value === 'object' && value !== null) {
          resetSectionFields(fieldPath, value);
        }
      });
    }
    else if (Array.isArray(formValues)) {
      setValue(sectionName, []);
    }
  };

  const resetAllergyFields = () => {
    setValue("medication_allergy[0].medication", "");
    setValue("medication_allergy[0].reaction", "");
    const allergies = getValues("medication_allergy");
    if (Array.isArray(allergies)) {
      allergies.forEach((_, index) => {
        setValue(`medication_allergy[${index}].medication`, "");
        setValue(`medication_allergy[${index}].reaction`, "");
      });
    }
  };

  const resetMedicationFields = () => {
    const medicationsFields = getValues("current_medications");
    if (Array.isArray(medicationsFields)) {
      for (let i = 0; i < medicationsFields.length; i++) {
        setValue(`current_medications[${i}].medication`, "");
        setValue(`current_medications[${i}].strength`, "");
        setValue(`current_medications[${i}].dosage_form`, "");
        setValue(`current_medications[${i}].frequency`, "");
      }
    }
  };

  useEffect(() => { if (profile && Object.keys(profile).length > 0) { reset(profile); } }, [profile, reset]);

  useEffect(() => {
    if (profile?.quit_date) {
      const formattedDate = moment(profile?.quit_date, ['DD/MM/YYYY', moment.ISO_8601]).format('YYYY-MM-DD');
      setQuitDate(formattedDate);
    }
  }, [profile, setQuitDate]);

  useEffect(() => {
    if (watchMedicalHistory) resetSectionFields("medical_history", allMedicalHistory);
    if (watchSurgicalHistory) resetSectionFields("surgical_history", allSurgicalHistory);
    if (watchNeverSmoker) resetSectionFields("social_history", allSocialHistory);
    if (watchNonAlcoholic) resetSectionFields("alcohol_history", allAlcoholHistory);
    if (watchNonDruggist) resetSectionFields("drug_history", allDrugHistory);
    if (watchNoMedication) resetMedicationFields();
    if (watchNoMedicationAllergy) resetAllergyFields();

    if (watchFormerSmoker) {
      ["everyday_smoker", "someday_smoker", "passive_smoker", "vaping"].forEach(field => setValue(`social_history.${field}`, false));
    }
    else { setValue("quit_date", "") }

  }, [
    watchMedicalHistory,
    watchSurgicalHistory,
    watchNeverSmoker,
    watchNonAlcoholic,
    watchNonDruggist,
    watchNoMedication,
    watchNoMedicationAllergy,
    watchFormerSmoker
  ]);
  return (
    <>
      <div className="comm_page_outer">
        <Container>
          <Header2 />
          <div className="comm_inner_page_layout">
            <section className="comm_form_border_box_row">
              <div className="comm_border_box">
                <div className="profile_main_page">
                  <div className="d-flex my_profile_row">
                    <div className="comm_profile_head_usr_detail">
                      <div className="profile-pic">
                        <Form.Control id="file" type="file" {...register("profile_picture")} />
                        <figure className="profile-img-edit">
                          <img src={profile.image ? `${IMAGE_URL}${profile.image}` : avtar} alt="" className="img-fluid" />
                        </figure>
                      </div>
                      <div className="name-all">
                        <h6>{profile?.full_name}</h6>
                        <p><AiOutlineMail />{profile?.email}</p>
                        <p><LuPhone />{profile?.number}</p>
                      </div>
                    </div>

                    <div className="comm-pair-btns d-flex align-items-center gap-3">
                      <button onClick={() => navigate('/edit-basic-information')} className="main-btn comm_icon_btn edit_profile_btn">
                        <FiEdit /> Edit Profile
                      </button>
                      <Link to="/change-password" className="main-outline-btn">Change Password</Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="comm_border_box">
                <Form className="comm_form" onSubmit={handleSubmit(editMedicalInfo)}>
                  <div className="past_hist_outer_row">
                    <div className="past_hist_col">
                      <h4 className="comm_inner_form_heading">Past Medical history</h4>
                      <h6 className="comm_inner_form_sub_heading">Please check any condition you have or have had?</h6>
                      <Form.Group className="custom-checkbox past_history_checkbox">
                        <Form.Check type="checkbox" className="ps-0" label="No medical history to report" id="no_medical_history" {...register("no_medical_history")} />
                      </Form.Group>

                      <div style={{ display: watchMedicalHistory ? 'none' : 'block' }}>
                        <div className="d-flex past_history_checkbox_row" >
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Allergies" id="med_allergies" {...register("medical_history.allergies")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Lung disease" id="med_lung_disease" {...register("medical_history.lung_disease")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Acid Reflux" id="med_acid_reflux" {...register("medical_history.acid_reflux")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Stroke" id="med_stroke" {...register("medical_history.stroke")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Anemia" id="med_anemia" {...register("medical_history.anemia")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Meningitis" id="med_meningitis" {...register("medical_history.meningitis")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Glaucoma" id="med_glaucoma" {...register("medical_history.glaucoma")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Substance Abuse" id="med_substance_abuse" {...register("medical_history.substance_abuse")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Arthritis" id="med_arthritis" {...register("medical_history.arthritis")} />
                            </Form.Group>
                          </div>
                        </div>
                        <div className="other_past_history_wrap">
                          <Form.Group className="custom-checkbox past_history_checkbox">
                            <Form.Check type="checkbox" className="ps-0" label="Others" id="med_others" {...register("medical_history.others")} />
                          </Form.Group>
                          {watchMedicalOthers &&
                            <Form.Group className="comn-class-inputs"
                              ref={node => {
                                if (node && errors?.medical_history?.others_specify) {
                                  node.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                  node.querySelector('textarea')?.focus();
                                }
                              }}>
                              <Form.Control as="textarea" rows={3} style={{ resize: "none", height: "9rem" }}
                                placeholder="Please Specify" disabled={!watchMedicalOthers}
                                {...register("medical_history.others_specify", {
                                  required: "This field is required.",
                                  validate: value => value.trim() !== '' || 'This field cannot be empty or only spaces.',
                                })}
                              />
                              {errors?.medical_history?.others_specify && (<span className="error">{errors?.medical_history?.others_specify?.message}</span>)}
                            </Form.Group>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="past_hist_col">
                      <h4 className="comm_inner_form_heading">Past Surgical History</h4>
                      <h6 className="comm_inner_form_sub_heading">Please check any surgery you have had?</h6>

                      <Form.Group className="custom-checkbox past_history_checkbox">
                        <Form.Check type="checkbox" className="ps-0" label="Never had surgery" id="never_had_surgery" {...register("never_had_surgery")} />
                      </Form.Group>
                      <div style={{ display: watchSurgicalHistory ? 'none' : 'block' }}>
                        <div className="d-flex past_history_checkbox_row">
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Allergies" id="surg_allergies" {...register("surgical_history.allergies")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Lung disease" id="surg_lung_disease" {...register("surgical_history.lung_disease")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Acid Reflux" id="surg_acid_reflux" {...register("surgical_history.acid_reflux")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Stroke" id="surg_stroke" {...register("surgical_history.stroke")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Anemia" id="surg_anemia" {...register("surgical_history.anemia")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Meningitis" id="surg_meningitis" {...register("surgical_history.meningitis")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Glaucoma" id="surg_glaucoma" {...register("surgical_history.glaucoma")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Substance Abuse" id="surg_substance_abuse" {...register("surgical_history.substance_abuse")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Arthritis" id="surg_arthritis" {...register("surgical_history.arthritis")} />
                            </Form.Group>
                          </div>
                        </div>
                        <div className="other_past_history_wrap">
                          <Form.Group className="custom-checkbox past_history_checkbox">
                            <Form.Check type="checkbox" className="ps-0" label="Orthopedic Surgery" id="orthopedic_surger" {...register("surgical_history.orthopedic_surgery")} />
                          </Form.Group>
                          {watchOrthopedicSurgery &&
                            <Form.Group className="comn-class-inputs"
                              ref={node => {
                                if (node && errors?.surgical_history?.orthopedic_specify) {
                                  node.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                  node.querySelector('textarea')?.focus();
                                }
                              }}>
                              <Form.Control
                                as="textarea" rows={3} style={{ resize: "none", height: "9rem" }} placeholder="Please Specify" disabled={!watchOrthopedicSurgery}
                                {...register("surgical_history.orthopedic_specify", {
                                  required: 'This field is required.',
                                  validate: value => value.trim() !== '' || 'This field cannot be empty or only spaces.',
                                })}
                              />
                              {errors?.surgical_history?.orthopedic_specify && (<span className="error">{errors?.surgical_history?.orthopedic_specify?.message}</span>)}
                            </Form.Group>
                          }
                        </div>
                        <div className="other_past_history_wrap">
                          <Form.Group className="custom-checkbox past_history_checkbox">
                            <Form.Check type="checkbox" className="ps-0" label="Others" id="surg_other" {...register("surgical_history.others")} />
                          </Form.Group>
                          {watchSurgicalOthers &&
                            <Form.Group className="comn-class-inputs"
                              ref={node => {
                                if (node && errors?.surgical_history?.others_specify) {
                                  node.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                  node.querySelector('textarea')?.focus();
                                }
                              }}>
                              <Form.Control as="textarea" rows={3} style={{ resize: "none", height: "9rem" }} placeholder="Please Specify" disabled={!watchSurgicalOthers}
                                {...register("surgical_history.others_specify", {
                                  required: 'This field is required.',
                                  validate: value => value.trim() !== '' || 'This field cannot be empty or only spaces.',
                                })}
                              />
                              {errors?.surgical_history?.others_specify && (<span className="error">{errors?.surgical_history?.others_specify?.message}</span>)}
                            </Form.Group>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="past_hist_col">
                      <h4 className="comm_inner_form_heading"> Social History </h4>
                      <h6 className="comm_inner_form_sub_heading"> Please check for smoking pattern. </h6>

                      <Form.Group className="custom-checkbox past_history_checkbox">
                        <Form.Check type="checkbox" className="ps-0" label="Never Smoker" id="never_smoker" {...register("never_smoker")} />
                      </Form.Group>
                      <div style={{ display: watchNeverSmoker ? 'none' : 'block' }}>
                        <div className="d-flex past_history_checkbox_row social_history_row">
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Current Every Day Smoker" id="everyday_smoker" disabled={watchFormerSmoker ? true : false} {...register("social_history.everyday_smoker")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Current Some Day Smoker" id="someday_smoker" disabled={watchFormerSmoker ? true : false} {...register("social_history.someday_smoker")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Passive Smoker (2nd Hand Smoke)" id="passive_smoker" disabled={watchFormerSmoker ? true : false} {...register("social_history.passive_smoker")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Vaping" id="vaping" disabled={watchFormerSmoker ? true : false} {...register("social_history.vaping")} />
                            </Form.Group>
                          </div>
                        </div>

                        <div className="other_past_history_wrap other_past_history_wrap2">
                          <Form.Group className="custom-checkbox past_history_checkbox">
                            <Form.Check type="checkbox" className="ps-0" label="Former Smoker" id="former_smoker" {...register("social_history.former_smoker")} />
                          </Form.Group>
                          <div style={{ display: !watchFormerSmoker ? 'none' : 'block' }}>
                            <Form.Group className="comn-class-inputs">
                              <Form.Label>Quit date</Form.Label>
                              <div className="cst_datepicker_outer">
                                <Form.Control type="date" placeholder="Enter quit date" value={quitDate}
                                  {...register('quit_date', {
                                    required: watchFormerSmoker ? 'Please select quit date.' : false,
                                    validate: (value) => {
                                      if (!value && watchFormerSmoker) return 'Please select quit date.';
                                      if (value) {
                                        const selectedDate = new Date(value);
                                        const currentDate = new Date();
                                        selectedDate.setHours(0, 0, 0, 0);
                                        currentDate.setHours(0, 0, 0, 0);
                                        return selectedDate < currentDate || 'Quit date cannot be today or in the future.';
                                      }
                                      return true;
                                    }
                                  })}
                                  onClick={(e) => e.target.showPicker()}
                                  onChange={(e) => setQuitDate(e.target.value)}
                                />
                              </div>
                              {errors.quit_date && <span className="error">{errors.quit_date.message}</span>}
                            </Form.Group>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="past_hist_col">
                      <h6 className="comm_inner_form_sub_heading">Please check for alcohol consumption pattern.</h6>
                      <div className="d-flex past_history_checkbox_row flex-column">
                        <div className="past_history_checkbox_col">
                          <Form.Group className="custom-checkbox past_history_checkbox">
                            <Form.Check type="checkbox" className="ps-0" label="Non Alcoholic" id="non_alcoholic" {...register("non_alcoholic")} />
                          </Form.Group>
                        </div>
                        <div style={{ display: watchAlcoholic ? 'none' : 'block' }}>
                          <div className="past_history_checkbox_col" >
                            <Form.Group className="custom-checkbox past_history_checkbox" >
                              <Form.Check type="checkbox" className="ps-0" label="Alcohol: Drinks/week" id="alcohol_drinks" checked={watchAlcoholic ? false : true} {...register("alcohol_history.alcohol_drinks")} />
                            </Form.Group>
                          </div>

                          <Row>
                            <Col md={6}>
                              <Form.Group className='comn-class-inputs'>
                                <Form.Label>Glasses of wine</Form.Label>
                                <Form.Control type="number" min={0} placeholder="Enter Glass Of Wine" {...register("alcohol_history.glasses_of_wine", { required: !watchAlcoholic ? "This field is required." : false })} />
                                {errors.alcohol_history?.glasses_of_wine && (<span className="error">{errors.alcohol_history.glasses_of_wine.message}</span>)}
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className='comn-class-inputs'>
                                <Form.Label>Cans of Beer</Form.Label>
                                <Form.Control type="number" min={0} placeholder="Enter Cans Of Beer" {...register("alcohol_history.cans_of_beer", { required: !watchAlcoholic ? "This field is required." : false })} />
                                {errors.alcohol_history?.cans_of_beer && (<span className="error">{errors.alcohol_history.cans_of_beer.message}</span>)}
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className='comn-class-inputs'>
                                <Form.Label>Shots of Liquor</Form.Label>
                                <Form.Control type="number" min={0} placeholder="Enter Shots Of Liquor" {...register("alcohol_history.shots_of_liquor", { required: !watchAlcoholic ? "This field is required." : false })} />
                                {errors.alcohol_history?.shots_of_liquor && (<span className="error">{errors.alcohol_history.shots_of_liquor.message}</span>)}
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className='comn-class-inputs'>
                                <Form.Label>Drinks <span> (containing 0.5oz of alcohol)</span></Form.Label>
                                <Form.Control type="number" min={0} placeholder="Enter Drinks Containing 0.5oz Of Alcohol" {...register("alcohol_history.drinks_with_alcohol", { required: !watchAlcoholic ? "This field is required." : false })} />
                                {errors.alcohol_history?.drinks_with_alcohol && (<span className="error">{errors.alcohol_history.drinks_with_alcohol.message}</span>)}
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    <div className="past_hist_col">
                      <h6 className="comm_inner_form_sub_heading">Please check for Drug pattern.</h6>
                      <Form.Group className="custom-checkbox past_history_checkbox">
                        <Form.Check type="checkbox" className="ps-0" label="Non - Druggist" id="non_druggist" {...register("non_druggist")} />
                      </Form.Group>
                      <div style={{ display: watchDruggist ? 'none' : 'block' }}>
                        <div className="d-flex past_history_checkbox_row drug_pattern_row">
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Marijuana" id="marijuana" {...register("drug_history.marijuana")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Cocaine" id="cocaine" {...register("drug_history.cocaine")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="Methamphetamines" id="methamphetamines" {...register("drug_history.methamphetamines")} />
                            </Form.Group>
                          </div>
                          <div className="past_history_checkbox_col">
                            <Form.Group className="custom-checkbox past_history_checkbox">
                              <Form.Check type="checkbox" className="ps-0" label="IV" id="iv" {...register("drug_history.iv")} />
                            </Form.Group>
                          </div>
                        </div>

                        <div className="other_past_history_wrap other_past_history_wrap2">
                          <Form.Group className="custom-checkbox past_history_checkbox" >
                            <Form.Check type="checkbox" className="ps-0" label="Drug use: Uses/week" id="drug_use_weekly" checked={!watchDruggist ? true : false} {...register("drug_history.drug_use_weekly")} />
                          </Form.Group>
                          <Form.Group className='comn-class-inputs' >
                            <Form.Label>Enter Frequency <span> (weekly)</span></Form.Label>
                            <Form.Control type="number" min={1} placeholder="Enter Frequency Here" disabled={watchDruggist} onKeyDown={(e) => keyHandler(e, false)}
                              {...register("drug_history.drug_use_frequency", { required: !watchDruggist ? "This field is required." : false })}
                            />
                            {errors.drug_history?.drug_use_frequency && <span className="error">{errors.drug_history?.drug_use_frequency.message}</span>}
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                    <div className="past_hist_col past_medical_bottm_sec">
                      <h4 className="comm_inner_form_heading"> Family Medical History</h4>
                      <h6 className="comm_inner_form_sub_heading grey"> Please write in any medical condition or disease that has been in your family </h6>
                      {FamilyMemberFields.map((field, index) => (
                        <Row key={index}>
                          <Col md={6}>
                            <Form.Group className="comn-class-inputs">
                              <Form.Label className="form-heading">Disease</Form.Label>
                              <div className="comn-class-inputs d-flex align-items-center mb-2">
                                <Form.Control type="text" placeholder="Enter Disease"
                                  {...register(`family_history.${index}.disease`, {
                                    required: "This field is required.",
                                    validate: value => value.trim() !== '' || 'This field cannot be empty or only spaces.',
                                  })}
                                />
                              </div>
                              {errors.family_history?.[index]?.disease && <span className="error">{errors.family_history[index]?.disease.message}</span>}

                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="comn-class-inputs">
                              <Form.Label>Family Member(S)</Form.Label>
                              <div className="flex items-center mb-2">
                                <Form.Control type="text" placeholder="Enter Family Member"
                                  {...register(`family_history.${index}.family_member`, {
                                    required: "This field is required.", validate: value => value.trim() !== '' || 'This field cannot be empty or only spaces.',
                                  })}
                                />
                                {errors.family_history?.[index]?.family_member && <span className="error">{errors.family_history[index]?.family_member.message}</span>}
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      ))}
                      <div className="add_more_history_btn" onClick={() => appendFamilyMember({ family_member: "" })}>+Add more members</div>
                      {FamilyMemberFields.length > 1 &&
                        <div className="add_more_history_btn" onClick={() => { removeFamilyMember(FamilyMemberFields.length - 1); }}> - Remove Member</div>
                      }
                    </div>
                    <div className="past_hist_col past_medical_bottm_sec">
                      <h4 className="comm_inner_form_heading"> Current Medications</h4>
                      <div className="past_history_checkbox_row">
                        <Form.Group className="custom-checkbox past_history_checkbox">
                          <Form.Check type="checkbox" className="ps-0" label="No Medications" id="no_medications" {...register("no_medication")} />
                        </Form.Group>
                      </div>
                      <div style={{ display: watchMediction ? "none" : "block" }}>
                        {medicineFields.map((field, index) => (
                          <Row key={field.id}>
                            <Col md={6}>
                              <Form.Group className='comn-class-inputs'>
                                <Form.Label>Medication</Form.Label>
                                <Form.Control type="text" placeholder="Enter Medication"
                                  disabled={watchMediction}
                                  {...register(`current_medications.${index}.medication`, {
                                    required: !watchMediction ? "This field is required." : false,
                                    validate: !watchMediction ? value => value.trim() !== '' || 'This field cannot be empty or only spaces.' : false,
                                  })}
                                />
                                {errors.current_medications?.[index]?.medication && <span className="error">{errors.current_medications[index]?.medication.message}</span>}
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className='comn-class-inputs'>
                                <Form.Label>Strength <span>(Dose)</span></Form.Label>
                                <div className="d-flex gap-2">
                                  <Form.Control type="number" min={1} placeholder="Enter Dose" disabled={watchMediction} onKeyDown={(e) => keyHandler(e, false)}
                                    {...register(`current_medications.${index}.strength`, { required: !watchMediction ? "This field is required." : false, })}
                                  />
                                  <Form.Select disabled={watchMediction} {...register(`current_medications.${index}.dosage_form`, { required: !watchMediction ? "Required" : false, })}>
                                    <option value="" disabled>Unit</option>
                                    <option value="mg">mg</option>
                                    <option value="mcg">mcg</option>
                                    <option value="g">g</option>
                                    <option value="mL">mL</option>
                                    <option value="drops">drops</option>
                                    <option value="tablets">tablets</option>
                                    <option value="capsules">capsules</option>
                                    <option value="puffs">puffs</option>
                                    <option value="units">units</option>
                                  </Form.Select>
                                </div>
                                {errors.current_medications?.[index]?.strength && <span className="error d-block">{errors.current_medications[index]?.strength.message}</span>}
                                {errors.current_medications?.[index]?.dosage_form && <span className="error d-block">{errors.current_medications[index]?.dosage_form.message}</span>}
                              </Form.Group>
                            </Col>
                            <Col md={12}>
                              <Form.Group className='comn-class-inputs'>
                                <Form.Label>How Often?<span>(Frequency) </span></Form.Label>
                                <Form.Control type="number" min={1} placeholder="Enter Frequency" disabled={watchMediction} onKeyDown={(e) => keyHandler(e, false)}
                                  {...register(`current_medications.${index}.frequency`, { required: !watchMediction ? "This field is required." : false })}
                                />
                                {errors.current_medications?.[index]?.frequency && <span className="error">{errors.current_medications[index]?.frequency.message}</span>}
                              </Form.Group>
                            </Col>
                          </Row>
                        ))}
                      </div>
                      {!watchMediction && <div className="add_more_history_btn" onClick={() => appendMedicine({ medication: "", strength: "", dosage_form: "", frequency: "" })}>+Add Another Medicine</div>}
                      {medicineFields.length > 1 && <div className="add_more_history_btn" onClick={() => removeMedicine(medicineFields.length - 1)}>-Remove Medicine</div>}
                    </div>
                    <div className="past_hist_col past_medical_bottm_sec">
                      <h4 className="comm_inner_form_heading"> Medication Allergies</h4>
                      <div className="past_history_checkbox_row">
                        <Form.Group className="custom-checkbox past_history_checkbox">
                          <Form.Check type="checkbox" className="ps-0" label="No known medication allergies" id="no_med_allergies" {...register("no_medication_allergy")} />
                        </Form.Group>
                      </div>
                      <div style={{ display: watchAllergies ? "none" : "block" }}>
                        {allergiesFields.map((fields, index) => (
                          <Row key={fields.id}>
                            <Col md={6}>
                              <Form.Group className='comn-class-inputs'>
                                <Form.Label>Medication</Form.Label>
                                <Form.Control type="text" placeholder="Enter Medication" disabled={watchAllergies}
                                  {...register(`medication_allergy.${index}.medication`, {
                                    required: !watchAllergies ? "This field is required." : false,
                                    validate: !watchAllergies ? value => value.trim() !== '' || 'This field cannot be empty or only spaces.' : false,
                                  })}
                                />
                                {errors.medication_allergy?.[index]?.medication && <span className="error">{errors.medication_allergy[index]?.medication.message}</span>}
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className='comn-class-inputs'>
                                <Form.Label>Reaction</Form.Label>
                                <Form.Control type="text" placeholder="Enter Reaction" disabled={watchAllergies}
                                  {...register(`medication_allergy.${index}.reaction`, {
                                    required: !watchAllergies ? "This field is required." : false,
                                    validate: !watchAllergies ? value => value.trim() !== '' || 'This field cannot be empty or only spaces.' : false,
                                  })}
                                />
                                {errors.medication_allergy?.[index]?.reaction && <span className="error">{errors.medication_allergy[index]?.reaction.message}</span>}
                              </Form.Group>
                            </Col>
                          </Row>
                        ))}
                      </div>
                      {!watchAllergies &&
                        <div className="add_more_history_btn" onClick={() => appendAllergy({ medication: "", reaction: '' })}>+Add more Allergies</div>}
                      {allergiesFields.length > 1 && <div className="add_more_history_btn" onClick={() => removeAllergy(allergiesFields.length - 1)}>-remove Medicine</div>}
                    </div>

                    <div className="past_hist_col past_medical_bottm_sec">
                      <h4 className="comm_inner_form_heading">Upload Past Medical History PDF</h4>
                      <p className="comm_inner_form_sub_heading">You can upload a new PDF file for your medical history here.</p>
                      <button type="button" className="main-btn" onClick={medical.toggleShow}>Upload Medical History</button>
                    </div>
                  </div>

                  <div className="dash-pair-btns-comn comm_form_same_sz_btns d-flex align-items-center gap-3 mt-5">
                    <Link to="/profile" className="main-outline-btn cancel" >Back</Link>
                    <button className="main-btn profile_form_comm_btn mt-0" type="submit">save changes</button>
                  </div>
                </Form>
              </div>
            </section>
          </div>
        </Container>
      </div>

      <Modal show={medical.show} onHide={medical.toggleShow} centered className="comm_modal logout_modal">
        <Modal.Body className="p-0">
          <Modal.Header><IoMdCloseCircle onClick={medical.toggleShow} /></Modal.Header>
          <div className="comm_inner_body_modal px-5">
            <h4> Please upload past medical history! </h4>
            <Row>
              <Col md={6}>
                <Form.Group className="comn-class-inputs">
                  <Form.Label>Age</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter Your Age e.g 18"
                    min={1}
                    max={125}
                    value={medical.age}
                    onChange={(e) => medical.setAge(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="comn-class-inputs">
                  <Form.Label>Select Your Gender</Form.Label>
                  <Form.Select value={medical.gender} onChange={(e) => medical.setGender(e.target.value)}>
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="others">Others</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="comn-class-inputs">
                  <Form.Label>Upload PDF</Form.Label>
                  <Form.Control type="file" accept="application/pdf" onChange={medical.handleFileChange} />
                </Form.Group>
              </Col>
            </Row>

            {medical.error && <span className="error d-block text-center mt-3">{medical.error}</span>}

            <div className="modal_pair_btns">
              <button type="button" className='main-outline-btn' onClick={medical.toggleShow} disabled={medical.uploading}>No</button>
              <button type="button" className="main-btn" onClick={medical.uploadMedicalHistory} disabled={medical.uploading}>{medical.uploading ? "Uploading..." : "Yes"}</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default EditMedicalHistory;